import axios from "axios";
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    // baseURL: "http://127.0.0.1:8000/api",
    crossDomain: "true",
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-with, Content-Type, Accept",
    },
});

export default instance;
